module.exports = __webpack_public_path__ + "img/bg-bucket.e121198c83707d805c1b29c0077a13d8.svg";